import React from 'react';
import { ConfirmDelete, ConfirmDeleteProps } from './ConfirmDelete';
import { Dialog } from './Dialog';

type ConfirmDeleteDialogProps = ConfirmDeleteProps;

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = props => {
  return (
    <Dialog hasHeader={true}>
      <ConfirmDelete {...props} />
    </Dialog>
  );
};
